const DOMAIN_REGEX =
  /^(https?:\/\/)?(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-zA-Z0-9-](\/?)$/i;

export const isDomainValid = (value: string) => {
  return DOMAIN_REGEX.test(value);
};
